import { cva } from "class-variance-authority";

export const avatarStyles = cva("min-w-0 shrink-0 focus-visible:shadow-none focus-visible:outline-hidden", {
  variants: {
    size: {
      "2xs": "h-4 w-4 min-w-4 text-[8px] leading-3",
      xs: "h-6 w-6 min-w-6 text-xs",
      sm: "h-8 w-8 min-w-8 text-sm",
      md: "h-10 w-10 min-w-10 text-base",
      lg: "h-12 w-12 min-w-12 text-lg",
      xl: "h-14 w-14 min-w-14 text-xl",
      "2xl": "h-16 w-16 min-w-16 text-2xl",
      "3xl": "h-20 w-20 min-w-20 text-2xl",
    },
    placeholderSize: {
      "2xs": "h-4 w-4",
      xs: "h-4 w-4",
      sm: "h-5 w-5",
      md: "h-6 w-6",
      lg: "h-7 w-7",
      xl: "h-8 w-8",
      "2xl": "h-8 w-8",
      "3xl": "h-10 w-10",
    },
    connectionIconSize: {
      "2xs": "h-1 w-1",
      xs: "h-1.5 w-1.5",
      sm: "h-2 w-2",
      md: "h-2.5 w-2.5",
      lg: "h-3 w-3",
      xl: "h-3.5 w-3.5",
      "2xl": "h-4 w-4",
      "3xl": "h-5 w-5",
    },
    connectionStatus: {
      online: "bg-success-50",
      offline: "bg-neutral-80",
    },
    companyIconSize: {
      "2xs": "h-2 w-2",
      xs: "h-2.5 w-2.5",
      sm: "h-3 w-3",
      md: "h-3.5 w-3.5",
      lg: "h-4 w-4",
      xl: "h-[18px] w-[18px]",
      "2xl": "h-5 w-5",
      "3xl": "h-6 w-6",
    },
    defaultVariants: {
      size: "sm",
      placeholder: "sm",
    },
  },
});

export const avatarTextStyles = cva("", {
  variants: {
    size: {
      "2xs": "gap-2 [&>div>.main-text]:text-xs [&>div>.sub-text]:text-[8px] [&>div>.sub-text]:leading-3",
      xs: "gap-2.5 [&>div>.main-text]:text-sm [&>div>.sub-text]:text-xs",
      sm: "gap-2.5 [&>div>.main-text]:text-sm [&>div>.sub-text]:text-xs",
      md: "gap-3 [&>div>.main-text]:text-sm [&>div>.sub-text]:text-sm",
      lg: "gap-3 [&>div>.main-text]:text-base [&>div>.sub-text]:text-base",
      xl: "gap-4 [&>div>.main-text]:text-lg [&>div>.sub-text]:text-base",
      "2xl": "gap-4 [&>div>.main-text]:text-xl [&>div>.sub-text]:text-lg",
      "3xl": "gap-4 [&>div>.main-text]:text-2xl [&>div>.sub-text]:text-xl",
    },
  },
});
